import { render, staticRenderFns } from "./AddShiftBasedBarTrendWidget.vue?vue&type=template&id=4f1bfd09"
import script from "./AddShiftBasedBarTrendWidget.vue?vue&type=script&lang=js"
export * from "./AddShiftBasedBarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports